import React, { memo, useRef, useState } from "react";
import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {
  ItemForcus,
  getDate,
  getGender,
  getTreatmentStatus,
  getAge,
  getDisplayAddress,
  convertKbToMb,
  formatMoney,
  getDateTime,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { useTranslation } from "react-i18next";
import CommonButton from "app/common/Component/Button/CommonButton";
import {
  Edit,
  ExitToAppOutlined,
  ExpandMore,
  OutdoorGrill,
  SyncAlt,
} from "@material-ui/icons";
import { useStore } from "app/stores";
import { Form, Formik, useFormikContext } from "formik";
import { toast } from "react-toastify";
import { IMAGE_SIZE } from "app/appConfig";
import { uploadAlbum } from "app/services/VisitService";
import ViewImageAvatar from "app/common/ViewImageAvatar";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { createPatient } from "app/services/PatientService";
import { observer } from "mobx-react";
import IconCrown from "app/common/Icon/IconCrown";
import { RANK_LIST } from "app/common/LocalConst";
import FilterListIcon from "@material-ui/icons/FilterList";
function TreamentInfoPatient({
  patient,
  patientId,
  initialPatient,
  currentTab,
  setCurrentTab,
}) {
  let currentRoomBed = "";
  if (patient?.currentBedName) {
    currentRoomBed = patient?.currentBedName;
  }
  if (patient?.currentRoomName) {
    if (currentRoomBed) currentRoomBed += " - ";
    currentRoomBed += patient?.currentRoomName;
  }
  const {
    openPopupPrintAll,
    handleOpenPopupPrintAll,
    handleClosePrintTreatmentPlan,
    allServicePatientData,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;
  return (
    <Grid component="section" item xs={12} md={12}>
      <Formik
        initialValues={{ patientAvatarId: patient?.patientAvatarId }}
        onSubmit={(values) => { }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <ValueForm
            patient={patient}
            patientId={patientId}
            handleOpenPopupPrintAll={handleOpenPopupPrintAll}
            openPopupPrintAll={openPopupPrintAll}
            handleClosePrintTreatmentPlan={handleClosePrintTreatmentPlan}
            allServicePatientData={allServicePatientData}
            initialPatient={initialPatient}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        </Form>
      </Formik>
    </Grid>
  );
}

const ValueForm = ({ patient, patientId, initialPatient, currentTab }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useTranslation();
  const isFirstTab = currentTab === 0;
  const { handleOpenFormCheckOut } =
    useStore().patientManagementStore.patientListStore;
  const { handleGetPatientOverviewById, getDataInvoiceDebtFee } =
    useStore().patientManagementStore.patientGeneralStore;
  const { handleOpenUncompletedServicePopup } =
    useStore().patientManagementStore.uncompletedRegisterServiceStore;
  const inputRef = useRef(null);

  const { setFieldValue, values } = useFormikContext();

  const handleClearImage = async () => {
    setFieldValue(`patientAvatarId`, null);
    await createPatient({
      ...patient,
      patientAvatarId: null,
    });
    await handleGetPatientOverviewById(patient?.id);
  };

  const handleAddImages = (id) => {
    setFieldValue("patientAvatarId", id);
  };

  async function uploadImages(e) {
    if (!e?.target?.files?.length) {
      toast.warning("Vui lòng chọn ảnh để tải lên");
      return;
    }
    const files = Array.from(e.target.files);
    const oversizedFiles =
      files.filter((file) => file?.size <= IMAGE_SIZE) || [];

    if (oversizedFiles.length > 0 && oversizedFiles.length < files?.length) {
      toast.warning(
        `Một số ảnh có kích thước vượt quá ${convertKbToMb(
          IMAGE_SIZE
        )}, hệ thông sẽ nhận những ảnh có kích thước dưới ${convertKbToMb(
          IMAGE_SIZE
        )}`
      );
    } else if (oversizedFiles.length === 0) {
      toast.warning(
        `Những hình ảnh có kích thước vượt quá ${convertKbToMb(
          IMAGE_SIZE
        )}, hệ thông chỉ nhận những ảnh có kích thước dưới ${convertKbToMb(
          IMAGE_SIZE
        )}`
      );
    }

    try {
      let { data: uploadedImages } = await uploadAlbum(oversizedFiles);
      if (uploadedImages.length > 0) {
        handleAddImages(uploadedImages?.[0]?.id);
        await createPatient({
          ...patient,
          patientAvatarId: uploadedImages?.[0]?.id,
        });
        await handleGetPatientOverviewById(patient?.id);
        toast.success("Tải lên thành công");
      } else {
        toast.error("Không có ảnh nào được tải lên");
      }
    } catch (error) {
      toast.error("Đã xảy ra lỗi trong quá trình tải ảnh");
    }
  }
  let color_rank =
    RANK_LIST.find((el) => patient?.currentPatientRank?.code === el?.code)
      ?.color || "#219d77";

  const totalToReceive = initialPatient?.totalAmountToReceive;
  const totalReceived = initialPatient?.totalAmountReceived;
  const missingAmount = totalToReceive - totalReceived;

  const formatMoneyVND = (amount) => {
    if (amount == null) return "0";
    return new Intl.NumberFormat("vi-VN", {
      maximumFractionDigits: 0,
    }).format(amount);
  };
  const [isOpenFillter, setOpenFillter] = useState(false);
  const isTablet = useMediaQuery("(min-width:960px) and (max-width:1279px)");
  // Tổng tiền thẻ còn lại có thể dùng = được dùng - đã dùng
  const cardAvailable =
    (initialPatient?.totalCardAmount || 0) -
    (initialPatient?.usedCardAmount || 0);
  // Tổng tiền cọc còn lại có thể dùng =  được dùng -  đã dùng
  const depositAvailable =
    (initialPatient?.totalDeposit || 0) -
    (initialPatient?.usedDepositAmount || 0);
  const isReadonly = isRoleHisReadOnly();
  return (
    <Grid
      container
      className="cards-container patient-info-container pl-2 pr-2 h-100"
      spacing={1}
    >
      {(!isMobile || isFirstTab) && (
        <Grid item xs={12} sm={6} md={isTablet ? 2 : 1}>
          <input
            type="file"
            onChange={uploadImages}
            className="display-none"
            ref={inputRef}
            accept="image/*"
          />

          <div
            className="flex align-center flex-column "
            style={{
              ...(isTablet && {
                width: "100%",
                alignItems: "center",
              }),
            }}
          >
            <ViewImageAvatar
              heightImg={isTablet ? "180px" : "100px"}
              widthImg={isTablet ? "180px" : "100px"}
              fileDescriptionId={values?.patientAvatarId}
              handleClearImage={handleClearImage}
              name={patient?.displayName}
            />
            <CommonButton
              className="btn-primary mt-1"
              onClick={() => inputRef.current.click()}
              style={{
                ...(isTablet && {
                  width: "100%",
                }),
              }}
            >
              <CloudDownloadIcon className="mr-2" /> Chọn ảnh
            </CommonButton>
          </div>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        md={isTablet ? 10 : 11}
        style={{ paddingLeft: isTablet ? 25 : 0 }}
      >
        <Grid
          container
          spacing={1}
          className={`info-name flex align-center ${isMobile && "flex-center"}`}
        >
          <Grid item lg={12} style={{ marginTop: "10px" }}>
            <Grid container spacing={1} className="flex-between">
              {(!isMobile || isFirstTab) && (
                <>
                  <Grid
                    item
                    xs={12}
                    lg={3}
                    md={4}
                    className="flex gap-1 justify-between align-center"
                  >
                    <ItemForcus
                      style={{ textAlign: "center" }}
                      label="Họ và Tên"
                      value={`${patient?.displayName}${patient?.birthDate &&
                        new Date(patient?.birthDate) > new Date("1920-01-01")
                        ? ` - ${getAge(patient?.birthDate)}`
                        : ""
                        }${(!isMobile || isFirstTab) && patient?.gender
                          ? ` - ${getGender(patient?.gender)}`
                          : ""
                        }`}
                    />
                    {/* {
                      isMobile &&
                      <Tooltip arrow title={"Chi tiết thông tin khách hàng"}>
                        <CommonButton
                          className="btn-filter"
                          color={"white"}
                          onClick={() => setOpenFillter(!isOpenFillter)}
                        >
                          <FilterListIcon color="red" />
                        </CommonButton>
                      </Tooltip>
                    } */}

                    {/* {(!isMobile || isFirstTab) && (
                    <div className="flex align-center mb-1 ">
                      <Tooltip title="Hạng khách hàng">
                        <div>
                          <IconCrown width={20} color={color_rank} />
                        </div>
                      </Tooltip>
                      <span style={{ color: color_rank }}>
                        {patient?.currentPatientRank
                          ? ` - ${patient?.currentPatientRank?.name}`
                          : ""}
                      </span>
                    </div>
                  )} */}
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label="Ngày sinh"
                      value={getDate(patient?.birthDate)}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("SĐT 1")}
                      value={patient?.phoneNumber}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    lg={3}
                    md={4}
                    className="flex justify-between align-center"
                  >
                    <ItemForcus
                      label="SĐT 2|3|4"
                      value={[
                        patient?.subPhoneNumber,
                        patient?.phoneNumber3,
                        patient?.phoneNumber4,
                      ]
                        .filter(Boolean)
                        .join(" | ")}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} className="flex ">
                    <ItemForcus
                      label={t("Nguồn hiện tại")}
                      value={patient?.currentPatientSource?.name}
                    />
                  </Grid>

                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus label={t("Mã Kh")} value={patient?.code} />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("CTV")}
                      value={initialPatient?.patientInfo?.referralPartnerName}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("Telesale hiện thời")}
                      value={
                        patient?.currentTelesale2
                          ? patient?.currentTelesale2?.staffName
                          : patient?.currentTelesale?.staffName
                      }
                    />
                  </Grid>
                </>
              )}

              {isOpenFillter && (
                <>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Đối tượng")}
                      value={patient?.currentPatientTypeService?.name}
                    />
                  </Grid>
                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("Địa chỉ")}
                      value={getDisplayAddress(patient)}
                    />
                  </Grid>

                  <Grid item xs={12} lg={3} md={4}>
                    <ItemForcus
                      label={t("patient.profession")}
                      value={patient?.profession?.name}
                    />
                  </Grid>

                  <Grid item xs={6} lg={3} md={4} className="flex gap-1">
                    <ItemForcus
                      label={t("Loại KH")}
                      value={patient?.currentPatientType?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4} className="flex">
                    <ItemForcus
                      label={t("Nhóm KH")}
                      value={patient?.currentPatientGroup?.name}
                    />
                  </Grid>
                  {(!isMobile || isFirstTab) && (
                    <>
                      <Grid item xs={6} lg={3} md={4}>
                        <ItemForcus
                          label={t("CSKH hiện thời")}
                          value={patient?.currentCustomerCareAgent?.staffName}
                        />
                      </Grid>
                      <Grid item xs={6} lg={3} md={4}>
                        <ItemForcus
                          label={t("Nguồn đầu tiên")}
                          value={patient?.firstPatientSource?.name}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Nguồn hiện tại (Chi tiết)")}
                      value={patient?.currentPatientSourceDetail?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Nguồn đầu tiên (Chi tiết)")}
                      value={patient?.firstPatientSourceDetail?.name}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Ngày giờ tạo")}
                      value={getDateTime(patient?.createDate)}
                    />
                  </Grid>
                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Người tạo")}
                      value={initialPatient?.createdBy}
                    />
                  </Grid>

                  <Grid item xs={6} lg={3} md={4}>
                    <ItemForcus
                      label={t("Người Checkin ")}
                      value={patient?.currentConsultant?.staffName}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={6} lg={3} md={4}></Grid>
              <Grid item xs={6} lg={3} md={4}></Grid>
            </Grid>
          </Grid>

          {/* tiền */}
          {(!isMobile || isFirstTab) && (
            <>
              <Grid item lg={12}>
                <Grid container spacing={1} className="patient-money-info">
                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <div className="field">
                      <Tooltip title="TỔNG TIỀN CỌC ĐƯỢC DÙNG">
                        <div className="flex align-center gap-1">
                          <label>Được dùng cọc</label>
                          <span class="badge badge-light-blue">
                            {formatMoneyVND(depositAvailable)}
                          </span>
                          {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                        </div>
                      </Tooltip>
                      {/* <Tooltip title="Tổng tiền cọc đã dùng">
                        <div>
                          <span class="badge badge-purple">
                            {formatMoneyVND(depositAvailable)}
                          </span>
                        </div>
                      </Tooltip> */}
                    </div>
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={3}>
                    <div className="field">
                      <Tooltip title="TỔNG TIỀN THẺ ĐƯỢC DÙNG">
                        <div className="flex align-center gap-1">
                          <label>Được dùng thẻ</label>
                          <span class="badge badge-light-blue">
                            {formatMoneyVND(cardAvailable)}
                          </span>
                          {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                        </div>
                      </Tooltip>
                      {/* <Tooltip title="TỔNG TIỀN THẺ ĐƯỢC DÙNG">
                        <div>
                          <span class="badge badge-yellow">
                            {formatMoneyVND(cardAvailable)}
                          </span>
                        </div>
                      </Tooltip> */}
                    </div>
                  </Grid>

                  {/*dịch vụ còn lại  */}
                  <Grid item xs={6} sm={6} md={3} lg={2}>
                    <div className="field">
                      <Tooltip title="Số lượng DV chưa điều trị xong">
                        <div
                          className="flex align-center gap-1"
                          onClick={() => {
                            handleOpenUncompletedServicePopup();
                          }}
                        >
                          <label>DV còn điều trị</label>
                          <span class="badge badge-light-blue">
                            {initialPatient?.numberOfServiceNotCompleted || 0}
                          </span>
                          {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                        </div>
                      </Tooltip>
                      {/* <Tooltip title="DỊCH VỤ CÒN LẠI">
                        <div>
                          <span class="badge badge-green">
                            {initialPatient?.numberOfServiceNotCompleted}
                          </span>
                        </div>
                      </Tooltip> */}
                    </div>
                  </Grid>

                  {/* CÔNG NỢ */}

                  {/* đã thanh toán  */}
                  <Grid item xs={6} sm={6} md={3} lg={2}>
                    <div className="field">
                      <Tooltip title="ĐÃ THANH TOÁN">
                        <div className="flex align-center gap-1">
                          <label>Đã thanh toán</label>
                          <span class="badge badge-light-blue">
                            {formatMoneyVND(initialPatient?.totalRevenue)}
                          </span>
                          {/* <ExpandMore
                            color="#4276a4"
                            style={{ width: "18px", marginBottom: "2px" }}
                          /> */}
                        </div>
                      </Tooltip>
                      {/* <Tooltip title="ĐÃ THANH TOÁN">
                        <div>
                          <span class="badge badge-pink">
                            {formatMoneyVND(initialPatient?.totalRevenue)}
                          </span>
                        </div>
                      </Tooltip> */}
                    </div>
                  </Grid>

                  <Grid item xs={6} sm={6} md={3} lg={2}>
                    <div className="field">
                      <Tooltip title="CÒN NỢ">
                        <div
                          className="flex align-center gap-1"
                          onClick={() => {
                            getDataInvoiceDebtFee({
                              patientId,
                              patient,
                            });
                          }}
                        >
                          <label>Còn nợ</label>
                          <span class="badge badge-pink">
                            {formatMoneyVND(missingAmount || 0)}
                          </span>
                        </div>
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}

          {/* phần này là các nút thao tác */}
          {(!isMobile || isFirstTab) && (
            <Grid
              item
              lg={12}
              style={{ borderTop: "1px solid #ccc", marginTop: "5px" }}
            >
              <div className={`flex gap-3 justify-end`}>
                {!isReadonly && (
                  <>
                    <span className="spacing-item"></span>
                    <div
                      onClick={() => {
                        handleOpenFormCheckOut(patient);
                      }}
                      className={"flex align-center gap-1 group-icon-btn"}
                    >
                      <ExitToAppOutlined className="mr-1 color-primary-icon" />{" "}
                      {!isMobile && "Check out"}
                    </div>
                    <span className="spacing-item"></span>
                    <Tooltip arrow title={"Xem chi tiết thông tin khách hàng"}>
                      <span
                        className={"flex align-center gap-1 group-icon-btn"}
                        color={"white"}
                        onClick={() => setOpenFillter(!isOpenFillter)}
                      >
                        ⛶{!isMobile && " Xem thêm"}
                      </span>
                    </Tooltip>
                    {/* <span className="spacing-item"></span> */}
                  </>
                )}
              </div>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(observer(TreamentInfoPatient));
